// Las direcciones del Centro de Alertas, en un solo lugar (contrato §4).
//
// `/alerts` es «Ahora» (F3): la bandeja de las alertas vigentes de todos los clientes. Con
// `NOW_VIEW_AVAILABLE` en false la ruta redirigía a «Mis reglas» y no había solapa ni «Ver qué disparó»;
// F3 lo prendió al montar la bandeja (`now/AlertsNowView`).
export const NOW_VIEW_AVAILABLE = true;

export const ALERTS_ROOT = '/alerts';
export const ALERTS_RULES = '/alerts/rules';
export const ALERTS_NEW = '/alerts/new';
// «Inversión sin control»: la plata que ninguna línea mira (frente del 05/10, Not Ordinary).
export const ALERTS_UNCONTROLLED = '/alerts/sin-control';
// «Avisos de las cuentas» (UD-18, 24/10): los avisos de control de Dashbo, en su propia página. Una ruta fija le gana a
// `/alerts/rules/:ruleId` en el ranking de React Router.
export const ALERTS_ACCOUNTS = '/alerts/rules/cuentas';

export const VIEW_NOW = 'now';
export const VIEW_RULES = 'rules';
export const VIEW_NEW = 'new';
export const VIEW_EDIT = 'edit';
export const VIEW_UNCONTROLLED = 'uncontrolled';
export const VIEW_ACCOUNTS = 'accounts';

// Parámetros de la URL: el filtro de la lista, la regla a resaltar y la regla a duplicar.
export const PARAM_FILTER = 'filtro';
export const PARAM_RULE = 'regla';
export const PARAM_DUPLICATE = 'duplicar';
// El link «Pausar esta regla» del correo (copy §5): abre la regla y pide confirmar en pantalla.
export const PARAM_PAUSE = 'pausar';
// «Crear una alerta» (UD-18): primero las sugeridas; con este parámetro, el constructor para armar una desde cero.
export const PARAM_SCRATCH = 'desde-cero';
// «Inversión sin control» de UN cliente (UD-5): la tarjeta de la ficha y el mail llevan a la solapa acotada.
export const PARAM_CLIENT = 'cliente';
// El Tablero con la tuerca de una columna abierta (v2): adonde lleva `?regla=system:<IND>` de una alerta
// que sólo pinta (Hoy, CPA, conversiones…), que ya no es una fila del Centro.
export const PARAM_GEAR = 'tuerca';
export const DASHBOARD_PATH = '/marketing';

export function columnGearPath(column) {
    return `${DASHBOARD_PATH}?${PARAM_GEAR}=${encodeURIComponent(column)}`;
}

/** La solapa «Inversión sin control», acotada a un cliente si viene `clientId`. */
export function uncontrolledPath({clientId = null} = {}) {
    if (clientId === null || clientId === undefined || clientId === '') return ALERTS_UNCONTROLLED;
    return `${ALERTS_UNCONTROLLED}?${PARAM_CLIENT}=${encodeURIComponent(clientId)}`;
}

export function rulePath(id) {
    return `${ALERTS_RULES}/${encodeURIComponent(id)}`;
}

export function systemRuleId(indicator) {
    return `system:${indicator}`;
}

/** El destino de la tuerca del Tablero: la fila de esa regla de sistema, resaltada. */
export function systemRulePath(indicator) {
    if (!indicator) return ALERTS_RULES;
    return `${ALERTS_RULES}?${PARAM_RULE}=${encodeURIComponent(systemRuleId(indicator))}`;
}

export function highlightRulePath(id) {
    return `${ALERTS_RULES}?${PARAM_RULE}=${encodeURIComponent(id)}`;
}

export function duplicateRulePath(id) {
    return `${ALERTS_NEW}?${PARAM_DUPLICATE}=${encodeURIComponent(id)}`;
}

/** Un aviso de control resaltado en «Avisos de las cuentas» (`?regla=` de un correo o de la lista). */
export function accountsRulePath(id) {
    return `${ALERTS_ACCOUNTS}?${PARAM_RULE}=${encodeURIComponent(id)}`;
}

/** «Armar una desde cero»: el constructor, sin las sugeridas. */
export const SCRATCH_PATH = `${ALERTS_NEW}?${PARAM_SCRATCH}=1`;

/** Una sugerida resaltada en «Crear una alerta» (`?regla=` que apunta a una que todavía no es fila). */
export function suggestionPath(systemKey) {
    return `${ALERTS_NEW}?${PARAM_RULE}=${encodeURIComponent(systemKey)}`;
}

/** «Ver qué disparó»: la bandeja «Ahora» filtrada por la regla (F3). */
export function ruleAlertsPath(id) {
    return `${ALERTS_ROOT}?${PARAM_RULE}=${encodeURIComponent(id)}`;
}

// «Mis alertas»: la pantalla del usuario donde elige qué tipos de alerta le llegan por correo.
export function myAlertsPath(userId) {
    return userId ? `/user/${encodeURIComponent(userId)}` : '/user-configuration';
}

// Donde se crea una métrica comparativa (lo que necesitan las reglas que no pueden alertar).
export const COMPARATIVE_METRICS_PATH = '/agency/personalization/columns';

export function lineAlertsConfigPath(businessUnitId) {
    return `/business-unit/${encodeURIComponent(businessUnitId)}/alerts-configuration`;
}
